import {
  Box,
  ListItemButton,
  ListItemIcon,
  ListItemText,
  Typography,
} from "@mui/material";
import { styled } from "@mui/material/styles";
import Drawer from "@mui/material/Drawer";
import pxToRem from "theme/base/pxToRem";
const handleColorNavItem = (
  theme: any,
  isActive: boolean,
  isActiveGroup: boolean
) => {
  if (isActive) return theme.palette.text.textLink;
  if (isActiveGroup) return theme.palette.text.textPrimary;
  return theme.palette.text.textWhite;
};

export const NavIconWrapper = styled(ListItemIcon)`
  min-width: 25px;
  padding-right: 10px;
  svg {
    font-size: ${pxToRem(20)};
  }
`;

export const NavTextWrapper = styled(ListItemText)`
  .MuiTypography-body1 {
    font-weight: ${({ theme }) => theme.typography.fw_regular_400};
    // white-space: nowrap;
  }
  padding-top: 2px;
`;

export const NavMenuWrapper = styled("div")<{
  isActive?: boolean;
}>`
  background-color: ${({ theme, isActive }) =>
    isActive ? theme.palette.background.bgMenuPrimary : "transparent"};
  border-radius: ${({ theme }) => theme.borders.borderRadius.lg_8};
  .MuiCollapse-wrapper {
    padding: 0 16px 16px 16px;
  }
`;

export const NavGroupWrapper = styled(ListItemButton)<{
  isActive?: boolean;
  position?: "top" | "bottom";
}>`
  padding: ${pxToRem(20)} ${pxToRem(16)};
  border-radius: ${({ theme }) => theme.borders.borderRadius.lg_8};
  border-bottom: solid 1px
    ${({ isActive, theme, position }) =>
      (position === "top" && !isActive && theme.palette.stroke.strokeMenu) ||
      "none"};
  border-top: solid 1px
    ${({ isActive, theme, position }) =>
      (position === "bottom" && !isActive && theme.palette.stroke.strokeMenu) ||
      "none"};
  background: ${({ theme, isActive }) =>
    isActive && theme.palette.background.bgMenuPrimary};
  font-size: ${({ theme }) => theme.typography.size.md_16};
  svg {
    path {
      fill: ${({ isActive, theme }) =>
        isActive ? theme.palette.text.textLink : theme.palette.text.textWhite};
    }
  }
  .MuiTypography-body1 {
    color: ${({ theme, isActive }) =>
      isActive ? theme.palette.text.textLink : theme.palette.text.textWhite};
  }
  &:hover {
    ${({ theme, isActive }) =>
      !isActive && "background:" + theme.palette.background.bgMenuBase2};
  } // hover cho menu khi đang active
`;

export const NavItemWrapper = styled(ListItemButton)<{
  isActive?: boolean;
  isActiveGroup?: boolean;
}>(({ theme, isActive, isActiveGroup }) => ({
  color: handleColorNavItem(theme, isActive, isActiveGroup),
  svg: {
    path: {
      fill: isActive
        ? theme.palette.text.textLink
        : theme.palette.text.textWhite,
    },
  },
  borderRadius: "2px 4px 4px 2px ",
  ".MuiTypography-root": {
    fontSize: theme.typography.size.sm_14,
  },
  borderLeft: isActive ? "2px solid" + theme.palette.text.textLink : "none",
  background: isActive
    ? theme.palette.background.bgBrandPrimary
    : "transparent",
  paddingLeft: "12px !important",
}));

export const InfoWrapper = styled(Box)<{ isMiniSidenav: boolean }>`
  background: ${({ theme }) => theme.palette.background.bgMenuBase2};
  padding: ${({ isMiniSidenav }) =>
    isMiniSidenav
      ? `${pxToRem(33)} ${pxToRem(16)} ${pxToRem(40)} ${pxToRem(16)}`
      : `${pxToRem(32)} ${pxToRem(24)} ${pxToRem(40)} ${pxToRem(24)}`};
`;
export const Menu = styled(Box)`
  padding: ${pxToRem(20)} ${pxToRem(16)} 0 ${pxToRem(24)};
  height: 100%;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
`;
//=========================================
interface OwnerState {
  isMiniSidenav: boolean;
}

export const DrawerSidenav = styled(Drawer)<{ ownerState: OwnerState }>(({
  theme,
  ownerState,
}) => {
  const { palette, transitions, breakpoints, functions } = theme;
  const { isMiniSidenav } = ownerState;
  const { background } = palette;
  const { pxToRem } = functions;

  const sidebarWidth = pxToRem(304);

  // styles for the sidenav when isMiniSidenav={false}
  const drawerOpenStyles = () => ({
    scrollbarGutter: "stable",
    background: background.bgMenuBase,
    transform: "translateX(0)",
    transition: transitions.create("transform", {
      easing: transitions.easing.sharp,
      duration: transitions.duration.shorter,
    }),

    [breakpoints.up("xl")]: {
      marginBottom: "inherit",
      left: "0",
      width: sidebarWidth,
      transform: "translateX(0)",
      transition: transitions.create(["width", "background-color"], {
        easing: transitions.easing.sharp,
        duration: transitions.duration.enteringScreen,
      }),
    },
  });

  // styles for the sidenav when isMiniSidenav={true}
  const drawerCloseStyles = () => ({
    background: background.bgMenuBase,
    transform: `translateX(${pxToRem(-320)})`,
    transition: transitions.create("transform", {
      easing: transitions.easing.sharp,
      duration: transitions.duration.shorter,
    }),

    [breakpoints.up("xl")]: {
      marginBottom: "inherit",
      left: "0",
      width: pxToRem(100),
      overflowX: "hidden",
      transform: "translateX(0)",
      transition: transitions.create(["width", "background-color"], {
        easing: transitions.easing.sharp,
        duration: transitions.duration.shorter,
      }),
    },
  });

  return {
    "& .MuiDrawer-paper": {
      border: "none",
      ...(isMiniSidenav ? drawerCloseStyles() : drawerOpenStyles()),
    },
  };
});

export const Version = styled(Typography)`
  font-size: ${pxToRem(10)};
  font-weight: ${({ theme }) => theme.typography.fw_thin_100};
  margin-top: ${pxToRem(4)};
  margin-bottom: ${pxToRem(5)};
  color: ${({ theme }) => theme.palette.text.textWhite};
  text-align: center;
`;
